import { render, staticRenderFns } from "./TemplateReportSortPage.vue?vue&type=template&id=74b74fa2"
import script from "./TemplateReportSortPage.vue?vue&type=script&lang=ts"
export * from "./TemplateReportSortPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports